import { z } from 'zod';

export const costCalculatorAuthenticatedGetResponseSchema = z.object({
  data: z.object({ show_cost_calculator: z.boolean().optional(), show_rental_rates: z.boolean().optional() }),
  response: z.object({ date: z.string(), messages: z.array(z.string()), status: z.number(), type: z.string() }),
});
